import * as React from "react";
import Box from "@mui/material/Box";
import { Link } from "react-router-dom";
import DataTools from "../../DataTools/DataTools";
import "../../SidebarMenu/categoryStyle.css";

const Swellable = () => {
  const displayedIds = [3];
  const displayedTool = DataTools.find((tool) =>
    displayedIds.includes(tool.id)
  );

  return (
    <Box className="main-box">
      <Box>
        <Link
          to={`/tool/details/3`}
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Box className="box">
            <img
              src={displayedTool.image}
              alt={`Tool ${displayedTool.id}`}
              className="image"
            />
          </Box>
          <Box className="title">
            <p>{displayedTool.title}</p>
          </Box>
        </Link>
      </Box>
    </Box>
  );
};
export default Swellable;
